<template>
  <div>
    <el-table :data="otcAuditList" height="calc(100vh - 260px)">
      <el-table-column label="租户" prop="tenantName" />
      <el-table-column prop="id" label="订单id">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.id }}</span>
          <span v-else>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topUserId" label="顶级合伙人"></el-table-column>
      <el-table-column prop="userId" label="用户Id">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.userId }}</span>
          <span v-else>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="下单方向">
        <template slot-scope="scope">
          {{ scope.row.orderSide == 1 ? '买' : '卖' }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="下单价格"></el-table-column>
      <el-table-column prop="unitPrice" label="实际价格"></el-table-column>
      <el-table-column prop="" label="下单币种数量">
        <template slot-scope="scope">
          <span> {{ scope.row.coinAmount }}</span>
          <span v-if="scope.row.coinAmount">
            {{ scope.row.coinType }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="下单法币数量">
        <template slot-scope="scope">
          {{ scope.row.amount }}{{ scope.row.currencyCoin }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="实际到账代币数量">
        <template slot-scope="scope">
          <span> {{ scope.row.successCoinAmount }}</span>
          <span v-if="scope.row.successCoinAmount">
            {{ scope.row.coinType }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="" label="实际法币到账数据">
        <template slot-scope="scope">
          <span> {{ scope.row.successAmount }}</span>
          <span v-if="scope.row.successAmount">{{
            scope.row.currencyCoin
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="创建时间" width="96">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="修改时间" width="96">
        <template slot-scope="scope">{{
          scope.row.updateTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="是否异常账户">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.mark === true">是</el-tag>
          <el-tag type="success" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status == -2"
            @click="doAudit(scope.row.id)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    >
    </pagination>
    <audit-detail :value="id" @onUpdate="onUpdate"></audit-detail>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import AuditDetail from '../detail'

export default {
  name: 'KYCAudit',
  data() {
    return {
      id: '',
    }
  },
  components: {
    Pagination,
    AuditDetail,
  },
  methods: {
    ...mapMutations('otcAudit', ['toggleDetailDialogVisible', 'setPagination']),
    ...mapActions('otcAudit', ['list']),
    doAudit(id) {
      this.id = id
      this.toggleDetailDialogVisible(true)
    },
    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', pagination)
    },
    onUpdate() {
      this.$emit('refresh')
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.mark === true) {
        return 'risk-row'
      }
      return ''
    },
  },
  computed: {
    ...mapGetters('otcAudit', ['otcAuditList']),
    ...mapState('otcAudit', ['pagination', 'totalCount']),
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-table .risk-row {
  background: #e9c0c0;

  &:hover > td.el-table__cell {
    background: #e9c0c0;
  }
}
.red {
  color: red;
  font-weight: bold;
}
</style>
